import { View } from "./View";

export interface IDatePickerProps {
  name: string;
  label: string;
  datePickerType?: "single" | "range";
  inputType?: string;
  placeholder?: string;
  defaultValue?: string | Date;
  minDate?: string | Date;
  maxDate?: string | Date;
  onChange: (value: string) => void;
  onClose?: (value: string) => void;
  onOpen?: (value: string) => void;
  onRenderedInputChange?: (value: string) => void;
  onRenderedInputClick?: (e: any) => void;
  disabled?: boolean;
  readOnly?: boolean;
  size?: "sm" | "md" | "lg";
  invalid?: boolean;
  invalidText?: string;
}

export const DatePicker = (props: IDatePickerProps) => {
  return <View {...props} />;
};
